import React, { useState } from "react";
import Form from "../../../../Components/Form";
import Workspace from "../../../../APIController/Workspace";
import Text from "../../../../Components/Text";
import TextInput from "../../../../Components/Form/TextInput";

const EditUserPasscodeermissionForm = ({afterAction, access, user})=>{
    const [passCode, setPassCode] = useState(access.numberCode || "0000")
    const {editUserPasscode} = Workspace()

    const handleEditPasscode = async()=>{
        const dto ={
            userCode: passCode
        }
        await editUserPasscode(user.id, dto)

        afterAction()
    }

    const handleSubmit = (e)=>{
        e.preventDefault()
        handleEditPasscode()
    }

    const handleNumberCheck = (e) => {
        const value = e.target.value;
        const numericOnly = value.replace(/[^0-9]/g, "");
        setPassCode(numericOnly);
    }

    return (
        <Form onSubmitAction={handleSubmit} submitButtonText={`Berechtigung Speichern`}>
            <Text type="maintitle" classNames={"flex text-center justify-center"}>{`${user.firstName} Passcode bearbeiten`}</Text>
            <TextInput attribute={passCode} id={"extraName"} label={"Name"} placeholder={"Extra Name"} action={handleNumberCheck}/>
        </Form>
    );
}

export default EditUserPasscodeermissionForm